import __request__ from "routing/request";
export function pause(nodeId, requestOptions) {
  return __request__("POST", `/cluster/${nodeId}/processing/pause`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function resume(nodeId, requestOptions) {
  return __request__("POST", `/cluster/${nodeId}/processing/resume`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
